import { IonCheckbox, IonContent, IonInput, IonItem, IonPage, IonText, IonSpinner } from "@ionic/react"
import moment, { months } from "moment";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";
import service from "../../Service/service";
import Head from "../Header";
import Sidebar from "../Sidebar";
import swal from 'sweetalert';
import { forEach } from "../../assets/plugins/fontawesome/js/v4-shims";
import MonthComp from "../MonthComp";
import DatePicker from "react-date-picker";

const MemberTimeSheet: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {

        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);

    const [data, setData]: any = useState([]);
    const [loading,setisloading]=useState(false)
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [Id] = useState(localStorage.getItem("SignupEmpId"));

    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);

    const [statusList, setStatusList]: any = useState([]);

    /*..................View Time Sheet.............. */

    const [fDate, setFDate] = useState("");
    const [tDate, setTDate] = useState("");
    const [status, setStatus] = useState("");
    const [hours, setHours] = useState("");
    const [respondedBy, setRespondedBy] = useState("");
    const [description, setdescription] = useState("");
    const [feedback, setFeedback] = useState("");
    const [timeloglist, setTimeloglist] = useState([]);
    const [viewMonth, setViewMonth] = useState("");
    const [viewWeek, setViewWeek] = useState("");
    timeloglist.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [timesheetId, setTimesheetId] = useState("");

    /*..................Create TimeSheet.............. */

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [Description, setDescription] = useState("");
    const [timelog, setTimelog]: any = useState([]);
    const [loglist, setloglist]: any = useState([]);
    const [month, setMonth]: any = useState([]);
    const [week, setWeek]: any = useState([]);
    loglist.forEach((item: any, index: any) => { item.serial = index + 1; });
    const [getMonth, setGetMonth] = useState([]);
    const [createdBy] = useState(localStorage.getItem("SignupEmpId"));

    const [safariMonth, setSafariMonth] = useState(null);
    // ................. Loading ................//

    const [isLoading, setIsLoading] = useState(false);

    var browser: any;

    useEffect(() => {
        //console.log("sdfcf",months)
        console.log("dasd", week)
        LoadTimeSheet();
        StatusDropDown();

        const userAgent = window.navigator.userAgent;
        if (userAgent.includes('Chrome')) {
            browser = "Chorme"
        } else if (userAgent.includes('Safari')) {
            browser = "Safari"
        } else {
            browser = ""
        }

        console.log(browser, "mkkk")
    }, []);

    const back = () => {
        history.goBack();
    }
    const LoadTimeSheet = () => {
        setisloading(true);
        service.GetAllEmployeeTimeSheet(Id)
            .then((response) => {
                console.log("RESPONSE", response);
                if (response.data.Status === '200') {
                    setData(response.data.Data);
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setisloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                },500); // Adjust the timeout duration as needed
            });
    };

    
    
    
    
    
    
    const renderResubmitButton = (status: any) => {
        if (status === "Rejected") {
            return (
                <div className="col">
                    <div className="submit-section">
                        <button
                            type="button"
                            className="btn-primary submit-btn"
                            onClick={ResubmitTimesheet}
                        >
                            Resubmit
                        </button>
                    </div>
                </div>
            );
        }
        return null;
    };

    //******************Getall details datatable*************//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px"
        },
        {
            name: "Week",
            selector: (itm: any) => itm.description,
            sortable: true,
            width: "320px"
        },
        {
            name: "Weekly Effort",
            selector: (itm: any) => itm.totalhours,
            sortable: true,
            width: "120px"
        },
        {
            name: "Create On",
            sortable: true,
            selector: (item: any) => moment(item.requestedDate).format("DD-MM-YYYY"),
        },
       {
            name: "Status",
            sortable: true,
            cell: (itm: any) => {
                const statusText = itm?.status?.status || "N/A";
                const statusClass =
                    statusText === "Approved"
                        ? "color_approve"
                        : statusText === "Open"
                            ? "color_progress"
                            : "color_deny";

                return <IonText className={statusClass}>{statusText}</IonText>;
            },
        },
        {
            name: "Approved By",
            selector: (itm: any) => itm.respondedBy,
            sortable: true,
            cell: (itm: any) => {
                var na = itm.respondedBy;
                var na1;
                if (na === null || na === "") {
                    na1 = "PENDING";
                }
                else {
                    na1 = na;
                }
                return (
                    <>
                        <IonText>{na1}</IonText>
                    </>
                )
            }
        },
        {
            name: " Action",
            sortable: false,
            width: "120px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText onClick={() => ViewTimesheet(itm.id)} style={{ color: "coral", cursor: 'pointer' }} >View</IonText>
                    </div>
                </>
            )
        }
    ];

    //********************View Datatable******************//

    const ViewColumns: any = [
        {
            name: "S.No",
            // width: "150px",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
        },
        {
            name: "Date",
            // width: "143px",
            selector: (itm: any) => moment(itm.date).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Project",
            sortable: true,
            // width: "200px",
            selector: (itm: any) => itm.project.projectName,
        },
        {
            name: "Activity",
            sortable: true,
            width: "300px",
            selector: (itm: any) => itm.activity,
        },
        {
            name: "Activity Description",
            sortable: true,
            width: "400px",
            // selector: (itm: any) => itm.workdescription,
            cell: (itm: any) => (
                <div style={{ whiteSpace: "pre-wrap", overflow: "pre-wrap" }}>
                    {itm.workdescription}
                </div>
            ),
        },
        {
            name: "Effort",
            sortable: true,
            // width: "200px",
            selector: (itm: any) => `${itm.hours}:${itm.minutes}`,
        },
    ];

    //*********************Create Timelog details Datatable*****************//

    const CreateColumns: any = [
        {
            name: "S.No",
            width: "50px",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
        },
        {
            name: "Date",
            selector: (itm: any) => moment(itm.date).format("DD-MM-YYYY"),
            sortable: true,
        },
        {
            name: "Project",
            sortable: true,
            widtth: "100px",
            selector: (itm: any) => itm.project.projectName,
        },
        {
            name: "Activity",
            sortable: true,
            width: "150px",
            selector: (itm: any) => itm.activity,
        },
        {
            name: "Activity Description",
            sortable: true,
            width: "200px",
            selector: (itm: any) => itm.workdescription,

        },
        {
            name: "Effort",
            sortable: true,
            width: "100px",
            selector: (itm: any) => itm.hours + "." + itm.minutes,
        },
    ];

    const customStyles = {
        headRow: {
            style: {
                // width:"100%"
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center"
            },
        },
        row: {
            style: {
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center",
                padding: "0px"
            }
        }
    };
    //********************View Timesheet Api****************//

    const ViewTimesheet = (id: any) => {
        setModalopen(true);
        service.ViewEmployeeTimeSheetById(id)
            .then((response) => {
                console.log(response.data, "ionr");
                setTimesheetId(response.data.Data.id);
              setStatus(response.data.Data.status?.status ?? "N/A");
                setFDate(response.data.Data.fromDate);
                setTDate(response.data.Data.toDate);
                setHours(response.data.Data.totalhours);
                setdescription(response.data.Data.description);
                setFeedback(response.data.Data.feedback);
                setRespondedBy(response.data.Data.respondedBy);
                if (response.data.Data.timeSheetLog != null || response.data.Data.timeSheetLog != "") {
                    setTimeloglist(response.data.Data.timeSheetLog);
                }
                else {
                    setTimeloglist([]);
                }
                setViewMonth(response.data.Data.month);
                setViewWeek(response.data.Data.week);
            })
    }

    //********************Resubmit Api*******************//

    const ResubmitTimesheet = () => {
        service.TimeSheetResubmit(timesheetId)
            .then((response) => {
                console.log("RESPONSE", response);
                if (response.data.Status === '200') {
                    swal("", "TimeSheet Resubmitted Successfully", "success");
                    window.location.reload()

                }
                else {
                    swal("", response.data.Message, "error");
                }

            })
    }
    const closemodal = () => {
        setModalopen(false);
        setStatus("");
        setFDate("");
        setTDate("");
        setHours("");
        setdescription("");
        setFeedback("");
        setRespondedBy("");
        setTimeloglist([]);
        setTimesheetId("");
    }

    const closemodal1 = () => {
        setFromDate("");
        setToDate("");
        setDescription("");
        setMonth([]);
        setWeek([]);
        setTimelog([]);
        setloglist([]);
        setModalopen1(false);
    }

    const openmodal1 = () => {
        setDescription("");
        setModalopen1(true);
    }

    //*****************Create Timesheet Api*******************//

    const CreateTimeSheet = () => {
        if (!month || (typeof month === 'string' && month.trim().length === 0)) {
            swal("", "Please Select Month", "info");
        }
        else if (week === "") {
            swal("", "Please Select Week", "info");
        }
        else if (timelog.length === 0) {
            swal("", "No Timelog found", "info");
        }
        else {
            setIsLoading(true);
            setTimeout(() => {
                service.TimesheetSave(Id, month, week, fromDate, toDate, Description, timelog)
                    .then((response) => {
                        console.log(response, "kmm")
                        if (response.data.Status === "200") {
                            swal({
                                title: "",
                                text: response.data.Message,
                                icon: "success",
                            }).then((value) => {
                                if (value) {
                                    window.location.reload();
                                }
                            });

                            console.log(response, "iorh");
                            setMonth(month);
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        } else {
                            swal("", response.data.Message, "info")
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        swal("", "Error occurred while saving the timesheet", "error");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }, 1000);
        }
    };

    //******************Month(First and last date of month)*************//

    const getmonth = (e: any) => {
        if (e) {
            setSafariMonth(e)
            const selectedDate = e
            const year = moment(selectedDate).format('YYYY');
            const months = moment(selectedDate).format('MM');

            const firstDate = moment(`${year}-${months}-01`, 'YYYY-MM-DD').toDate();
            const lastDate = moment(`${year}-${months}`, 'YYYY-MM').endOf('month').toDate();
            console.log('First Date:', firstDate);
            console.log('Last Date:', lastDate);
            const fromDate = moment(firstDate).format("YYYY-MM-DD");
            const toDate = moment(lastDate).format("YYYY-MM-DD");
            const month = year + ("-") + months;
            console.log('First Date:', fromDate);
            console.log('Last Date:', toDate);
            console.log("month", month)
            console.log("date", selectedDate)
            service.WeekList(fromDate, toDate)
                .then((response) => {
                    console.log(response);
                    if (response.status === 200) {
                        setGetMonth(response.data);
                        setMonth(month)
                    } else {
                        setGetMonth([])
                    }
                })
            setWeek(week)
        }
    }

    //****************Get Week of the month***************//

    const getweek = (e: any) => {
        const selectedOption = e.target.value;
        const weekIndex = selectedOption.indexOf('Week');
        //setWeek(e.target.options[weekIndex].getAttribute('label'));
        const datesStartIndex = selectedOption.indexOf('(', weekIndex) + 1;
        const datesEndIndex = selectedOption.indexOf(')', datesStartIndex);
        const datesString = selectedOption.substring(datesStartIndex, datesEndIndex);
        const datesArray = datesString.split(' to ');
        const fromDate = moment(datesArray[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        const toDate = moment(datesArray[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
        setDescription("Timesheet - " + "(" + datesString + ")");
        setFromDate(fromDate);
        setToDate(toDate);
        console.log("weeks", datesString)
        service.TimelogGetinTimeSheet(fromDate, toDate, createdBy)
            .then((response) => {
                console.log(response, "TimelogList");
                if (response.data.status === "200") {
                    setloglist([]);
                    setTimelog([]);
                    setWeek(e.target.value)
                    for (let j = 0; j < response.data.Data.length; j++) {
                        if (response.data.Data[j].status != true) {
                            setTimelog((e: any) => [
                                ...e, response.data.Data[j].id
                            ])
                        }
                    }
                    for (let i = 0; i < response.data.Logs.length; i++) {
                        if (response.data.Logs[i].status != true) {
                            setloglist((e: any) => [
                                ...e, response.data.Logs[i]
                            ])
                        }
                    }
                }
                else {
                    setloglist([]);
                    setTimelog([]);
                }
            })
        for (let i = 0; i < statusList.length; i++) {
            if (statusList[i].status === "Open") {
                setStatus(statusList[i].id);
            }
        }
    }

    //**************Status Api**************//

    const StatusDropDown = () => {
        service.TimeSheetCreateStatusDropDown()
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    setStatusList(response.data.Data);
                }
                else {
                    setStatusList([]);
                }
            })
    }

    //*****************Search filter***************//

    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);


    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Time Sheet</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => openmodal1()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Time Sheet</a>
                                </div>
                            </div>
                            {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/*................View TimeSheet........... */}
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    id="logouts-modal"
                    show={modalopen}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Time Sheet</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Month </label>
                                        <div>
                                            <IonInput value={viewMonth} readonly type="month" className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Week </label>
                                        <div>
                                            <IonInput value={viewWeek} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Status </label>
                                        <div>
                                            <IonInput value={status} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Hours </label>
                                        <div>
                                            <IonInput value={hours} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Responded By </label>
                                        <div>
                                            <IonInput value={respondedBy} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Description </label>
                                        <div>
                                            <IonInput value={description} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Feedback </label>
                                        <div>
                                            <IonInput value={feedback} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive" style={{ marginTop: "1%" }}>
                            <label style={{ fontWeight: "bold" }}>Time Log</label>
                            <DataTable
                                columns={ViewColumns}
                                data={timeloglist}
                                noDataComponent="Data not found !"
                                pagination
                                paginationPerPage={3}
                                paginationComponentOptions={paginationComponentOptions}
                                paginationRowsPerPageOptions={[3, 6, 9, 12]}
                                customStyles={customStyles}
                            />
                        </div>
                        <div className="row">
                            {renderResubmitButton(status)}
                            <div className="col">
                                <div className="submit-section">
                                    <button
                                        type="button"
                                        className="btn-primary submit-btn"
                                        onClick={closemodal}
                                    >
                                        Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/*................. Create TimeSheet............... */}
                <Modal dialogClassName="modal-dialog modal-lg"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Create Time Sheet</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Months </label>
                                    {/* {browser === "Safari" ? */}
                                    <div>
                                        {/* <ion-datetime presentation="month-year" ></ion-datetime> */}
                                        <DatePicker clearIcon={null} maxDetail="year" format="MM/yyyy" value={safariMonth} className="form-control" onChange={getmonth} />
                                    </div>
                                    {/* //     :
                                    //     <div>
                                    //         <IonInput type='month' onIonChange={(e: any) => getmonth(e)} className="form-control datetimepicker" />
                                    //     </div>

                                    // } */}
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Week </label>
                                    <select onChange={(e: any) => getweek(e)} className="select" style={{
                                        backgroundColor: '#ffffff',
                                        color: '#000000',
                                    }}>
                                        <option disabled selected value="">Select Week</option>
                                        {getMonth.map((itm: any, i: any) => {
                                            return (
                                                <option value={itm}>{itm}</option>


                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label style={{ fontWeight: "bold" }}>Description </label>
                                    <div>
                                        <IonInput value={Description} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                    </div>
                                </div>
                                <div className="table-responsive" style={{ marginTop: "1%" }}>
                                    <label style={{ fontWeight: "bold" }}>Time Log</label>
                                    {loglist.length > 0 ?
                                        <DataTable
                                            columns={CreateColumns}
                                            data={loglist}
                                            noDataComponent="Data not found !"
                                            pagination
                                            paginationPerPage={3}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[3, 6, 9, 12]}

                                            customStyles={customStyles}
                                        /> : <></>}
                                </div>
                                {isLoading && (
                                    <div
                                        style={{
                                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                        }}
                                    >
                                        <div >
                                            <IonSpinner style={{
                                                width: "40px",
                                                height: "40px",
                                                color: "#ff8a53"
                                            }} name="lines" />
                                        </div>
                                    </div>
                                )}
                                <div className="submit-section">
                                    <button type="button" className="btn-primary submit-btn" onClick={CreateTimeSheet}>Create</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}
export default MemberTimeSheet;








































